/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * FR API Documentation
 * OpenAPI spec version: 1
 */

export type GetDocumentsFormatConditionsSignificant = typeof GetDocumentsFormatConditionsSignificant[keyof typeof GetDocumentsFormatConditionsSignificant];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetDocumentsFormatConditionsSignificant = {
  NUMBER_0: 0,
  NUMBER_1: 1,
} as const;
